import * as React from 'react'
import { Helmet } from 'react-helmet'

import { useActiveStoreView, useStoreViews } from '@emico/storeviews'

import { useCategoryMeta } from '../actions/storeView/GetCategoryMeta.query'

interface Props {
    id: number
}

const CategoryCanonicals = ({ id }: Props) => {
    const { code: activeStoreViewCode } = useActiveStoreView()
    const storeViews = useStoreViews()

    const getStoreViewByCode = (storeCode: string) =>
        storeViews.find(({ code }) => code === storeCode)

    const result = useCategoryMeta(activeStoreViewCode, id)

    const Links = Object.entries(result?.data || {}).reduce(
        (prevValue: React.ReactNode[], currValue) => {
            const [storeCode, value] = currValue
            const { urlKey, breadcrumbs } = value

            if (!urlKey) {
                return prevValue
            }
            const fullCategoryUrl: string[] = []

            if (breadcrumbs) {
                const copy = [...breadcrumbs]

                copy.sort((a, b) => a.categoryLevel - b.categoryLevel).forEach(
                    (cat) => {
                        fullCategoryUrl.push('/', cat.categoryUrlKey)
                    },
                )
            }

            fullCategoryUrl.push('/', urlKey)
            const pathname = fullCategoryUrl.join('')

            const storeView = getStoreViewByCode(storeCode)

            const href = storeView && storeView?.makeUrl(pathname)

            const links = [
                <link
                    key={storeCode}
                    rel="alternate"
                    href={href}
                    hrefLang={storeView?.hrefLang}
                />,
            ]

            if (storeView?.hrefLang === 'x-default') {
                links.push(
                    <link
                        key={storeCode}
                        rel="alternate"
                        href={href}
                        hrefLang={storeView.locale || storeView.language}
                    />,
                )
            }
            if (activeStoreViewCode === storeCode) {
                return [
                    ...prevValue,
                    ...links,
                    <link key={storeCode} rel="canonical" href={href} />,
                ]
            }
            return [...prevValue, ...links]
        },
        [],
    )

    return <Helmet>{Links}</Helmet>
}

export default CategoryCanonicals
